export default "__VITE_ASSET__steA5fe4__"